import accounting from 'accounting-js';
import SMP_CONFIG from '@/util/smp_config';
import { first, last, get } from 'lodash';
const version = require('../../package.json').version;

const formatCurrency = num => {
  if (isNaN(num)) return null;
  return accounting.formatMoney(num, accounting.settings.currency);
};

const getCurrencySymbol = () => {
  if (SMP_CONFIG && SMP_CONFIG.countryConfig &&
    SMP_CONFIG.countryConfig.currency &&
    SMP_CONFIG.countryConfig.currency.symbol) {
    return SMP_CONFIG.countryConfig.currency.symbol;
  } else if (SMP_CONFIG && SMP_CONFIG.countryConfig &&
    SMP_CONFIG.countryConfig.countryCode &&
    SMP_CONFIG.countryConfig.currency) {
    // if currency symbol is missing in context country config, return it based on country-language
    return Number().toLocaleString(`${SMP_CONFIG.countryConfig.countryCode}-${getCurrentLanguage()}`,
      { style: 'currency', currency: SMP_CONFIG.countryConfig.currency.code || 'EUR' }).slice(-1);
  }
  return '€';
};

const getCurrentLanguage = () => {
  return SMP_CONFIG.countryConfig.defaultLanguageCode;
};

const getCurrencySymbolPosition = () => {
  // depending on the language/country pair, the currency symbol is placed either before or after the number
  let str = new Intl.NumberFormat(`${getCurrentLanguage()}-${SMP_CONFIG.countryConfig.countryCode}`,
    { style: 'currency', currency: SMP_CONFIG.countryConfig.currency.code || 'EUR' }).format(1000.1);
  if ((str.indexOf(getCurrencySymbol()) > -1) && (str.indexOf(getCurrencySymbol()) < 2)) {
    return '%s%v';
  }
  return '%v %s';
};

const getThousandSeparator = () => {
  return new Intl.NumberFormat(`${getCurrentLanguage()}-${SMP_CONFIG.countryConfig.countryCode}`).format(1000.1).slice(1, 2);
};

const getDecimalSeparator = () => {
  return new Intl.NumberFormat(`${getCurrentLanguage()}-${SMP_CONFIG.countryConfig.countryCode}`).format(1000.1).slice(5, 6);
};

const getLastestBookedOfferKey = (serviceCase) => {
  let latestBooking = last(serviceCase.bookedOfferKeys);
  if (latestBooking) {
    return latestBooking.value;
  }
};

const getDefaultSignature = () => {
  const regionSelectionConfig = SMP_CONFIG.applicationConfig.regionSelectionConfig;
  const preSelectedRegion = first(regionSelectionConfig.preselectedRegions);
  return regionSelectionConfig &&
    (
      regionSelectionConfig.defaultRegionSignature ||
      (preSelectedRegion && preSelectedRegion.signature)
    );
};

const unformatCurrencyString = (val) => {
  if (val === null || val === undefined || val === '') return null;

  val = val.toString().replace(/[^0-9$.,]/g, '');
  if (!val && val !== 0) return null;

  return accounting.unformat(val,
    Math.max(val.lastIndexOf(','), val.lastIndexOf('.')) === val.lastIndexOf(',') ? ',' : '.');
};

const isSingleService = () => {
  return get(SMP_CONFIG, 'contextConfig.extended.featureConfig.singleService');
};

const applicationVersion = () => version;

const getParameterByName = (name) => {
  const url = window.location.href;
  let regex = new RegExp('[?&]' + name + '(=([^&#/]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default {
  applicationVersion,
  formatCurrency,
  getCurrencySymbol,
  getCurrencySymbolPosition,
  getThousandSeparator,
  getDecimalSeparator,
  getLastestBookedOfferKey,
  getDefaultSignature,
  unformatCurrencyString,
  getCurrentLanguage,
  isSingleService,
  getParameterByName
}
